import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  RecoverPassword: lazy(() => import('src/pages/auth/jwt/recover-password')),
  ChangePassword: lazy(() => import('src/pages/auth/jwt/change-password'))
};

const authJwt = {
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: 'Gestisci la clientela con la consulenza potenziata' , subtitle:"La piattaforma web per consulenti finanziari"},
            }}
          >
            <Jwt.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'recover-password',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: 'Gestisci la clientela con la consulenza potenziata' , subtitle:"La piattaforma web per consulenti finanziari"},
            }}>
            <Jwt.RecoverPassword />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'change-password',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: 'Gestisci la clientela con la consulenza potenziata' , subtitle:"La piattaforma web per consulenti finanziari"},
            }}>
            <Jwt.ChangePassword />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    }
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authJwt],
  },
];
